import { render, staticRenderFns } from "./InformacoesClube.vue?vue&type=template&id=3f86d218"
import script from "./InformacoesClube.vue?vue&type=script&lang=ts"
export * from "./InformacoesClube.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports